<template>
  <div class="financeManage-orderList-page">
    <p class="hasBottomLine">借贷宝订单管理</p>
    <div class="header-seach-box">
      <div class="setDatePicker">
        <span class="setPading">下单时间</span>
        <el-date-picker
          v-model="serchStartTime"
          value-format="timestamp"
          type="datetime"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        <span class="setPading">至</span>
        <el-date-picker
          v-model="serchEndTime"
          value-format="timestamp"
          type="datetime"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </div>

      <div class="setDatePicker">
        <span class="setPading">订单状态：</span>
        <el-select
          v-model="serchStatus"
          slot="prepend"
          @change="hanldSerchStatus()"
          placeholder="请选择"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="审核中" value="0"></el-option>
          <el-option label="贷款中" value="1"></el-option>
          <el-option label="已完成" value="2"></el-option>
          <el-option label="已取消" value="3"></el-option>
          <el-option label="强平中" value="4"></el-option>
          <el-option label="已强平" value="5"></el-option>
        </el-select>
      </div>

      <div class="setDatePicker" style="margin-left: 30px">
        <el-button type="success" round @click="clearSearh()"
          >清空筛选条件</el-button
        >
      </div>
    </div>
    <div class="header-seach-box">
      <div class="inpuBox">
        <el-input
          v-model="mortgageCoinParam"
          placeholder="请输入抵押币种"
        ></el-input>
        <el-input
          v-model="borrowCoinParam"
          placeholder="请输入借贷币种"
        ></el-input>
      </div>

      <div class="inputWithSelectBox">
        <el-input
          :placeholder="selectType == '1' ? '下单用户账户' : '请输入订单编号'"
          v-model="serchInput"
          class="input-with-select"
        >
          <el-select
            v-model="selectType"
            slot="prepend"
            @change="hanldSelectType()"
            placeholder="请选择"
          >
            <el-option label="下单账户" value="1"></el-option>
            <el-option label="订单编号" value="2"></el-option>
          </el-select>
          <el-button
            slot="append"
            @click="getPageListInfo()"
            icon="el-icon-search"
            >搜索</el-button
          >
        </el-input>
      </div>
      <!-- <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加方案</el-button> -->
    </div>
    <!-- <div class="show-tag-wrap">
      <el-checkbox v-model="showTagUser" @change="changeShowTag()" label="展示标签用户"></el-checkbox>
    </div> -->

    <div class="table-box">
      <el-table :data="orderListInfo" border style="width: 99.9%">
        <el-table-column property="id" label="订单编号" width="160">
          <template slot-scope="scope">
            <span @click="toGoDetailPage(scope.row.id)" class="lianJie">{{
              scope.row.id
            }}</span>
          </template>
        </el-table-column>
        <el-table-column property="userId" label="下单用户账户" width="160">
          <template slot-scope="scope">
            <span @click="showBalance(scope.row.userId)" class="lianJie">{{
              scope.row.userId
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="tagName"
          label="标签"
        ></el-table-column>
        <el-table-column
          property="tagDesc"
          label="标签描述"
        ></el-table-column>
        <el-table-column
          property="mortgageCoin"
          label="抵押币种"
          width="160"
        ></el-table-column>
        <el-table-column
          property="mortgageAmount"
          label="抵押数量"
          width="160"
        ></el-table-column>
        <el-table-column
          property="borrowCoin"
          label="借贷币种"
        ></el-table-column>
        <el-table-column
          property="borrowAmount"
          label="借贷数量"
        ></el-table-column>
        <el-table-column property="address" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0"> 审核中</span>
            <span v-else-if="scope.row.status == 1"> 贷款中</span>
            <span v-else-if="scope.row.status == 2"> 已完成</span>
            <span v-else-if="scope.row.status == 3"> 已取消</span>
            <span v-else-if="scope.row.status == 4"> 强平中</span>
            <span v-else-if="scope.row.status == 5"> 已强平</span>
          </template>
        </el-table-column>

        <el-table-column
          property="interestAmount"
          label="借贷利息"
        ></el-table-column>
        <el-table-column
          property="borrowTime"
          label="已借贷时长/天数"
        ></el-table-column>
        <el-table-column
          property="riskRate"
          label="订单风险率（%）"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.riskRate * 100 }} %</span>
          </template>
        </el-table-column>
        <el-table-column property="" label="下单时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column property="" label="审核不通过理由" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.reason || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column property="" label="备注" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="remarkBtn(scope.row)"
              >备注</el-button
            >
            <el-button
              type="danger"
              v-if="scope.row.status == 0"
              @click="auditBtn(scope.row)"
              >订单审核</el-button
            >
            <el-button
              type="warning"
              v-if="scope.row.status == 4 || scope.row.status == 5"
              @click="toGoblastPage(scope.row.id)"
              >查看强平</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="orderListTotal"
      >
      </el-pagination>
    </div>

    <!---dialog--->

    <el-dialog
      title="订单审核"
      class="bk-ui5-dialog"
      :visible.sync="auditDialog"
    >
      <div class="xiaLaBox">
        <el-select
          v-model="auditStatus"
          slot="prepend"
          @change="hanldAuditXiala()"
          placeholder="请选择"
        >
          <el-option label="审核不通过" value="3"></el-option>
          <el-option label="审核通过" value="1"></el-option>
        </el-select>
      </div>
      <div class="miaosu" v-if="auditStatus == 3">
        <p class="redText">审核不通过，订单将会直接取消，请添加原因：</p>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入不通过原因"
          show-word-limit
          maxlength="120"
          v-model="auditReason"
        >
        </el-input>
      </div>
      <div class="miaosu" v-else>
        <p class="blueText">审核通过立即放款，请保证平台借贷宝账户币量充足。</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialog = false">取 消</el-button>
        <el-button type="primary" @click="auditCommitBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加备注"
      class="bk-ui5-dialog"
      :visible.sync="reamrkDialog"
    >
      <div class="miaosu">
        <p class="redText">请描述备注信息：</p>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请描述备注信息："
          show-word-limit
          maxlength="120"
          v-model="reamrkValue"
        >
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="reamrkDialog = false">取 消</el-button>
        <el-button type="primary" @click="remarkCommitBtn()">确 定</el-button>
      </div>
    </el-dialog>
    <balance ref="balanceRef"></balance>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import Balance from "./Balance.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Precept",
  data() {
    return {
      auditStatus: "3", // 1通过，3不通过
      auditReason: "",
      reamrkValue: "",
      reamrkDialog: false,
      auditDialog: false,
      serchStatus: "9",
      borrowCoinParam: "",
      mortgageCoinParam: "",

      editInfo: {},
      selectType: "1",
      serchInput: "",
      serchStartTime: "",
      serchEndTime: "",

      currentPage: 1,
      pageSize: 7,
      showTagUser: false
    };
  },
  computed: {
    ...mapState("FinanceManage", ["orderListInfo", "orderListTotal"]),
  },
  methods: {
    ...mapActions("FinanceManage", ["getOrderList"]),
    hanldAuditXiala() {
      this.auditReason = "";
    },

    hanldSelectType() {
      this.serchInput = "";
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },
    toGoDetailPage(id) {
      this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id);
    },
    toGoblastPage(orderId) {
      this.$router.push(
        "/home/finance/manage/mortgage/blastList?orderId=" + orderId
      );
    },
    clearSearh() {
      this.serchStatus = "9";
      this.borrowCoinParam = "";
      this.mortgageCoinParam = "";
      this.selectType = "1";
      this.serchInput = "";
      this.serchStartTime = "";
      this.serchEndTime = "";
      this.getPageListInfo();
    },
    hanldSerchStatus() {
      this.getPageListInfo();
    },
    remarkBtn(row) {
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.reamrkValue = this.editInfo.remark;
      this.reamrkDialog = true;
    },
    remarkCommitBtn() {
      let that = this;
      let postData = {
        orderId: this.editInfo.id,
        remark: this.reamrkValue,
      };
      api.remarkOrder(postData).then((res) => {
        if (!res.code) {
          that.getPageListInfo();
          that.$message.success(res.msg);
          that.reamrkDialog = false;
          that.reamrkValue = "";
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    auditBtn(row) {
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.auditDialog = true;
    },
    auditCommitBtn() {
      let that = this;
      let postData = {
        orderId: this.editInfo.id,
        reason: this.auditReason,
        status: this.auditStatus,
      };
      api.auditOrder(postData).then((res) => {
        if (!res.code) {
          that.getPageListInfo();
          that.$message.success(res.msg);
          that.auditDialog = false;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getPageListInfo() {
      let userId = "";
      let orderId = "";
      let status = "";
      if (this.selectType == "1") {
        userId = this.serchInput;
        orderId = "";
      } else {
        userId = "";
        orderId = this.serchInput;
      }

      if (this.serchStatus == "9") {
        status = "";
      } else {
        status = this.serchStatus;
      }

      let postData = {
        page: this.currentPage,
        size: this.pageSize,
        borrowCoin: this.borrowCoinParam,
        mortgageCoin: this.mortgageCoinParam,
        orderId: orderId,
        userId: userId,
        endTime: this.serchEndTime,
        startTime: this.serchStartTime,
        status: status,
      };

      this.getOrderList(postData);
    },
    showBalance(uid) {
      this.$refs["balanceRef"].setUid(uid);
      this.$refs["balanceRef"].setVisible(true);
    },
    changeShowTag() {},

    handleSearch() {},
  },
  created() {
    if (this.$route.query.blastId) {
      this.selectType = "1";
      this.serchInput = this.$route.query.blastId;
    }
  },
  mounted() {
    this.getPageListInfo();
  },
  components: {
    Balance,
  },
};
</script>

<style lang="less">
.financeManage-orderList-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 20px;
    display: flex;

    .inpuBox {
      display: flex;
      .el-input {
        margin-right: 20px;
      }
    }
    .inputWithSelectBox {
      width: 700px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 200px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .setDatePicker {
      color: #409eff;
      .setPading {
        padding: 0 15px;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
        .lianJie {
          color: #409eff;
          cursor: pointer;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .titleStrong {
          font-size: 18px;
          font-weight: bold;
        }

        .xiaLaBox {
          width: 80%;
        }
        .miaosu {
          .redText {
            color: red;
          }
          .blueText {
            color: #409eff;
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
